import { render, staticRenderFns } from "./InfoBottom.vue?vue&type=template&id=c27ca680&scoped=true&"
import script from "./InfoBottom.vue?vue&type=script&lang=js&"
export * from "./InfoBottom.vue?vue&type=script&lang=js&"
import style0 from "./InfoBottom.vue?vue&type=style&index=0&id=c27ca680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27ca680",
  null
  
)

export default component.exports